//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { bagItemDesc } from "@/api/financial/consumptionDetails";
import { template } from "lodash";
import { mapState } from "vuex";
import { gmTool } from "@/mixins/index";
export default {
  name: 'watchBackPackDetails',
  mixins: [gmTool],
  data: function data() {
    return {
      dialogShow: false,
      list: []
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      console.log("data===", data);
      this.list = JSON.parse(JSON.stringify(data.rewards));
      this.dialogShow = true;
    }
  }
};